import { render, staticRenderFns } from "./FinalizacaoAnexos.vue?vue&type=template&id=4d554808"
import script from "./FinalizacaoAnexos.vue?vue&type=script&lang=js"
export * from "./FinalizacaoAnexos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports